import { render, staticRenderFns } from "./baseLevelModification.vue?vue&type=template&id=58e52cb2&scoped=true&"
import script from "./baseLevelModification.vue?vue&type=script&lang=js&"
export * from "./baseLevelModification.vue?vue&type=script&lang=js&"
import style0 from "./baseLevelModification.vue?vue&type=style&index=0&id=58e52cb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e52cb2",
  null
  
)

export default component.exports